import { useEffect, useMemo, useState } from 'react';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import AddIcon from '@mui/icons-material/Add';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import { useDispatch, useSelector } from 'react-redux';
import LocalizedStrings from 'react-localization';
import LOCALIZATIONS from './localizations';
import './style.css';
import { CURRENT_NODE, ZOOM } from '../../redux/actions/board';
import { MODAL_TOGGLE, WALKTHROUGH_START } from '../../redux/actions/app';
import { ID as CREATE_NODE_MODAL_ID } from '../CreateNode/config';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const Toolbar = () => {

    const dispatch = useDispatch(),
    labels = useMemo( () => new LocalizedStrings( LOCALIZATIONS ), []),
    locale = useSelector( state => state.app.locale ),
    forceOpen = useSelector( state => state.app.walkthrough.openToolbar ),
    [ open, setOpen ] = useState( false );

    /**
     * @name addNode
     * @function
     * @description Adds a node to the board
     */
    const addNode = () => {
        dispatch({ type: CURRENT_NODE });
        dispatch({ type: MODAL_TOGGLE, payload: CREATE_NODE_MODAL_ID });
    }

    /**
     * @name startWalkthrough
     * @function
     * @description Starts the walkthrough
     */
    const startWalkthrough = () => {
        dispatch({ type: WALKTHROUGH_START });
    }

    /**
     * @name toggle
     * @function
     * @description Toggles the toolbar open or closed
     * @param {boolean} state 
     * @returns {function}
     */
    const toggle = state => () => {
        setOpen( state )
    }

    /**
     * @name zoom
     * @function
     * @description Zooms the view in or out
     * @param {boolean} direction `true` to zoom in, `false` to zoom out
     * @returns {function}
     */
    const zoom = payload => () => {
        dispatch({ type: ZOOM, payload });
    }

    // update locale
    useEffect(() => {
        if( locale !== labels.getLanguage() ) labels.setLanguage( locale )
    }, [ labels, locale ]);

    useEffect(() => {
        setOpen( forceOpen );
    }, [ forceOpen, setOpen ]);

    return (
        <SpeedDial
            ariaLabel={ labels.options }
            disabled={ forceOpen }
            className="coe__toolbar"
            open={ open }
            onClick={ toggle( !open ) }
            icon={ <SpeedDialIcon /> }
            sx={{ position: 'fixed', bottom: 16, right: 16 }}>
            <SpeedDialAction disabled={ forceOpen } className="coe__toolbar__add" key={ labels.addNode } icon={ <AddIcon /> } onClick={ addNode } tooltipTitle={ labels.addNode } aria-label={ labels.addNode } />
            <SpeedDialAction disabled={ forceOpen } key={ labels.zoomIn } icon={ <ZoomInIcon /> } onClick={ zoom( true ) } tooltipTitle={ labels.zoomIn } aria-label={ labels.zoomIn } />
            <SpeedDialAction disabled={ forceOpen } className="coe__toolbar__zoomOut" key={ labels.zoomOut } icon={ <ZoomOutIcon /> } onClick={ zoom( false ) } tooltipTitle={ labels.zoomOut } aria-label={ labels.zoomOut } />
            <SpeedDialAction disabled={ forceOpen } open className="coe__toolbar_startWalkthrough" key={ labels.walkthrough } icon={ <HelpOutlineIcon /> } onClick={ startWalkthrough } tooltipTitle={ labels.walkthrough } aria-label={ labels.walkthrough } />
        </SpeedDial>
    )

}

export default Toolbar;